import * as t from "io-ts";
export const routingT = t.strict({
    id: t.string,
    routeId: t.string,
    sections: t.array(t.string),
    points: t.array(t.array(t.number)),
    distanceInKm: t.number,
    allowTravelByFerry: t.boolean,
    fastestRoute: t.boolean,
});
//# sourceMappingURL=routing.js.map